<template>
  <div v-if="isRoot">
    <loader v-if="loading" position="fixed" />

    <div v-if="serviceAccounts">
      <b-col>
        <b-row class="align-items-center">
          <h5 class="mb-3 d-flex align-items-center">
            {{ $t('resources.block_titles.service_accounts') }}
          </h5>
          <b-col class="align-self-end mb-4">
            <b-button
              @click="addServiceAccount"
              variant="outline-primary"
              size="sm"
              style="height: 40px; width: 40px"
            >
              <i class="fas fa-plus fa-lg" />
            </b-button>
          </b-col>
        </b-row>

        <ServiceAccountSettings
          v-for="(serviceAccount, index) in serviceAccounts"
          :key="index"
          :service-account="serviceAccount"
          @update="fetchServiceAccounts"
          @delete="onDelete(serviceAccount)"
        />
      </b-col>
    </div>
    <modal
      :show-modal="showDeleteModal"
      :title="modalTitle"
      :confirm="modalOkTitle"
      @ok="removeServiceAccount"
      @hide="cancelDelete"
    />
  </div>
</template>

<script>
import i18n from '@/utils/i18n';
import fields from '../resourcesEditingFields';
import ServiceAccountSettings from './ServiceAccountSettings';
import { orderBy } from 'lodash';
export default {
  name: 'ServiceAccountsEditing',
  middleware: 'auth',
  components: { ServiceAccountSettings },
  data() {
    return {
      removableServiceAccount: {},
      showDeleteModal: false,
      fields: fields,
      loading: false,
      serviceAccounts: [],
      modalTitle: '',
      modalOkTitle: '',
    };
  },
  mounted() {
    this.fetchServiceAccounts();
  },
  computed: {
    isRoot() {
      return this.$store.getters['auth/role'] === 'root';
    },
  },
  methods: {
    addServiceAccount() {
      const newAccount = {
        id: Date.now(),
        api_key: '',
        title: '',
        user_id: null,
        description: '',
        full_access: false,
      };

      this.addReactiveItemToArray(this.serviceAccounts, newAccount);
    },
    onDelete(serviceAccount) {
      this.removableServiceAccount = serviceAccount;

      if (serviceAccount.suspended || serviceAccount.api_key === '') {
        this.modalTitle = i18n.t('resources.service_accounts.delete_message');
        this.modalOkTitle = i18n.t('button.delete');
      } else {
        this.modalTitle = i18n.t('resources.service_accounts.suspend_message');
        this.modalOkTitle = i18n.t('button.suspend');
      }

      this.showDeleteModal = true;
    },
    cancelDelete() {
      this.showDeleteModal = false;
      this.removableServiceAccount = {};
      this.modalTitle = '';
      this.modalOkTitle = '';
    },
    removeServiceAccount() {
      this.loading = true;
      try {
        if (this.removableServiceAccount.api_key && this.removableServiceAccount.suspended) {
          // If service account is created and suspended
          this.deleteServiceAccount();
        } else if (
          this.removableServiceAccount.api_key &&
          !this.removableServiceAccount.suspended
        ) {
          // If service account is created and not suspended
          this.suspendServiceAccount();
        } else {
          // If service account is not created
          this.fetchServiceAccounts();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    suspendServiceAccount() {
      this.putData(`resources/service-accounts/${this.removableServiceAccount.id}/suspend`)
        .then(() => {
          this.removableServiceAccount = null;
          this.showDeleteModal = false;
          this.fetchServiceAccounts();
        })
        .catch((error) => {
          if (error && error.response) {
            console.log('suspend service account error', error);
            this.$noty.error(error.response.data.error_description);
          }

          this.loading = false;
        });
    },
    deleteServiceAccount() {
      this.deleteData(`resources/service-accounts/${this.removableServiceAccount.id}`)
        .then(() => {
          this.removableServiceAccount = {};
          this.showDeleteModal = false;
          this.fetchServiceAccounts();
        })
        .catch((error) => {
          if (error && error.response) {
            console.log('delete service account error', error);
            this.$noty.error(error.response.data.error_description);
          }

          this.loading = false;
        });
    },
    fetchServiceAccounts() {
      this.loading = true;
      return this.getData('resources/service-accounts').then((response) => {
        if (response) {
          const { data } = response;

          this.serviceAccounts = orderBy(data.items, ['id', 'asc']);
          this.loading = false;
        }
      });
    },
  },
};
</script>
